import React from 'react';

// Renders one dropdown per Action.variations[] entry (e.g. "Seed Mix",
// "Planting Date") so farmers can pick the sub-option applicable to their
// bid. Selections are stored as { variationName: optionName } and sent to
// the backend as Bid.selectedVariations, which formulaEvaluator.js applies
// as a per-outcome multiplier — see backend/models/Action.js.
const ActionVariationsPicker = ({ variations, selected, onChange, styles }) => {
    if (!variations || variations.length === 0) return null;

    return (
        <div style={{ marginBottom: '15px' }}>
            {variations.map(variation => (
                <div key={variation.variationName} style={{ marginBottom: '10px' }}>
                    <label style={styles.label}>{variation.variationName}</label>
                    <select
                        style={styles.select}
                        value={selected?.[variation.variationName] || ''}
                        onChange={(e) => onChange(variation.variationName, e.target.value)}
                    >
                        <option value="">-- Choose {variation.variationName} --</option>
                        {variation.options.map(opt => (
                            <option key={opt.optionName} value={opt.optionName}>{opt.optionName}</option>
                        ))}
                    </select>
                </div>
            ))}
        </div>
    );
};

export default ActionVariationsPicker;
